// Importaciones de React, hooks y los logos de las alianzas.
import React from 'react';
import { useInView } from 'react-intersection-observer'; // Hook para detectar cuándo un elemento entra en la pantalla.

// Importación de todos los logos.
import kore from '../logos/kore.svg';
import microsoft from '../logos/microsoft.png';
import lumu from '../logos/lumu.png';
import fortinet from '../logos/fortinet.png';
import appgate from '../logos/appgate.png';
import axur from '../logos/axur.png';
import know from '../logos/know.png';

/**
 * Array que contiene los logos importados.
 * Se utiliza `.reverse()` para cambiar el orden en que se mostrarán.
 */
const logos = [
  know,
  axur,
  microsoft,
  appgate,
  fortinet,
  kore,
  lumu
].reverse();

/**
 * Componente Alianzas.
 * Muestra una sección con los logos de los socios comerciales.
 * La sección tiene un efecto de animación que se activa al hacerse visible en la pantalla.
 */
const Alianzas = () => {
  /**
   * Hook `useInView` de `react-intersection-observer`.
   * `ref`: Se asigna al elemento que queremos observar.
   * `inView`: Es un booleano que será `true` cuando el elemento esté en el viewport.
   * `triggerOnce: true`: La animación solo se ejecutará la primera vez que el elemento sea visible.
   * `threshold: 0.5`: La animación se disparará cuando el 50% del elemento sea visible.
   */
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="text-black py-10">
      {/* 
        Este div actúa como el contenedor de la animación.
        Se le asigna la `ref` para que `useInView` pueda observarlo.
        Aunque no es un componente de Framer Motion, la intención parece ser usar `inView`
        para controlar clases de CSS o un estado que active una animación.
        (Nota: El código original tiene props de Framer Motion como `initial`, `animate`, `variants`
        pero no importa `motion` de Framer. Lo comentaré como si la intención fuera usarlo).
      */}
      <div
        ref={ref}
        // Las siguientes propiedades funcionarían con <motion.div> de framer-motion.
        // initial="hidden"
        // animate={inView ? "visible" : "hidden"}
        // variants={{
        //   visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
        //   hidden: { opacity: 0, y: 50 },
        // }}
        // Aplicamos una transición simple basada en el estado `inView`.
        className={`transition-opacity duration-700 ${inView ? 'opacity-100' : 'opacity-0'}`}
      >
        {/* Contenedor principal con fondo, padding y bordes redondeados. */}
        <div className='bg-[#92C1DE] items-center p-6 max-w-7xl h-auto mx-auto rounded-2xl shadow-lg'>
          
          {/* Título de la sección. */}
          <h2 className="text-4xl font-bold text-center mb-10 my-14">ALIANZAS COMERCIALES</h2>
          
          {/* Línea decorativa. */}
          <div className='linea mt-5'></div>

          {/* Contenedor flex para los logos, con wrap para que se ajusten en pantallas pequeñas. */}
          <div className="flex justify-around flex-wrap">
            {/* Itera sobre el array de logos para mostrarlos. */}
            {logos.map((logo, idx) => (
              <div key={idx} className="px-4 flex justify-center items-center">
                <img 
                  src={logo} 
                  alt={`Logo de alianza ${idx + 1}`} 
                  className="h-16 object-contain m-10 max-w-full" 
                  style={{ maxWidth: '200px' }} 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// Exporta el componente para su uso en otras páginas.
export default Alianzas;
